import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';
import ResponsiveImage from "../../components/ResponsiveImage/ResponsiveImage";
import '../../components/Accordion/Accordion.css'


const ConstructPage = ({ beforeRoute, title }) => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/fleet.json`);
    const {
        pageTitle,
        pageSubtitle,
    } = data
    const _beforeRoutes = [
        {
            "label": "Home",
            "value": "/"
        }
    ]
    if (beforeRoute) _beforeRoutes.push({
        "label": beforeRoute,
        "value": null,
        "disabled": true
    })

    return (

        <>
            <div className='main-container' style={{
                minHeight: 'calc(100vh - var(--height-header) - 462px)'
            }}>
                <section className="section-container">

                </section>
            </div>
        </>
    )
}

export default ConstructPage